import Command from '@ckeditor/ckeditor5-core/src/command';

export default class MediaStyleCommand extends Command {
    execute(options) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const selectedMedia = selection.getSelectedElement();

        model.change(writer => {
            // Aplicar el estilo al medio seleccionado
            writer.setAttribute('mediaStyle', options.value, selectedMedia);
        });
    }

    refresh() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const selectedMedia = selection.getSelectedElement();

        // Habilitar el comando solo cuando hay un medio seleccionado
        this.isEnabled = selectedMedia && selectedMedia.name === 'media';
        this.value = selectedMedia ? selectedMedia.getAttribute('mediaStyle') : null;
    }
}
